import { useState } from 'react';

type Group = {
  name: string;
  platform: string;
  capacity: string;
  code: string;
  note: string;
  icon: string;
};

export default function GroupCard({ group }: { group: Group }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(group.code);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="card-rise flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:p-6">
      <div className="flex items-start justify-between gap-4">
        <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
          <i className={`${group.icon} text-2xl`}></i>
        </span>
        <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
          {group.platform}
        </span>
      </div>
      <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{group.name}</h3>
      <p className="mt-2 text-xs leading-6 text-foreground-500">{group.note}</p>

      <div className="mt-4 flex items-center justify-between rounded-md border border-dashed border-background-300 bg-background-100 px-4 py-3">
        <span className="font-mono text-sm tracking-wider text-foreground-900">{group.code}</span>
        <button
          type="button"
          onClick={copy}
          className="flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className={copied ? 'ri-check-line' : 'ri-file-copy-line'}></i>
          {copied ? '已复制' : '复制'}
        </button>
      </div>

      <p className="mt-4 flex items-center gap-1.5 text-xs text-foreground-500">
        <i className="ri-information-line"></i>
        {group.capacity}
      </p>
    </div>
  );
}